module.exports = __webpack_public_path__ + "img/DualRing-1.1s-28px.1b4cc490.svg";